export default __webpack_public_path__ + "static/media/red-candy.3658b37c.png";